/* PRICE DROP program: live toggle on variant change + Swatch King badges. No-op when no variant has custom.price_drop. */
(function(){
  function maps(){var out={};document.querySelectorAll('script[data-price-drop-map]').forEach(function(s){try{out[s.dataset.priceDropMap]=JSON.parse(s.textContent||'{}')}catch(e){out[s.dataset.priceDropMap]={}}});return out}
  var M=maps();
  function norm(x){return String(x||'').trim().toLowerCase()}
  function setMain(pid,vid){
    var m=M[pid]||{},d=m[String(vid)];
    document.querySelectorAll('[data-pd-holder="'+pid+'"]').forEach(function(h){
      h.classList.toggle('pd-active',!!d);
      h.querySelectorAll('[data-pd-pill],[data-pd-note]').forEach(function(e){e.hidden=!d});
      if(d){var o=h.querySelector('[data-product-price-sale="'+pid+'"]');if(o){o.textContent=d.orig;o.classList.remove('hide')}}
    });
  }
  function curVid(pid){
    var i=document.querySelector('input[data-bstr-variant-input="'+pid+'"]')||document.querySelector('form[action*="/cart/add"] [name="id"]');
    var u=new URLSearchParams(location.search).get('variant');
    return (i&&i.value)||u;
  }
  function tileText(li){
    var c=[li.getAttribute('orig-value'),li.getAttribute('data-value'),li.getAttribute('data-option-value'),li.getAttribute('aria-label'),li.getAttribute('title')];
    var inp=li.querySelector('input');if(inp)c.push(inp.value,inp.getAttribute('orig-value'),inp.getAttribute('aria-label'));
    var lab=li.querySelector('label');if(lab)c.push(lab.getAttribute('aria-label'),lab.getAttribute('title'));
    var t=li.querySelector('.swatch-img-text-adjacent,.swatch-variant-name,.swatch-button-title-text');if(t)c.push(t.textContent);
    return c.filter(Boolean).map(norm);
  }
  function badges(){
    /* speed-1019: the tile badges only apply to Swatch King tiles; its embed is off, so skip the scan when none are on the page */
    if(!document.querySelector('variant-swatch-king li.swatch-view-item'))return;
    Object.keys(M).forEach(function(pid){
      var m=M[pid],byOpt={};Object.keys(m).forEach(function(vid){(m[vid].options||[]).forEach(function(o){(byOpt[norm(o)]=byOpt[norm(o)]||[]).push(vid)})});
      document.querySelectorAll('variant-swatch-king li.swatch-view-item').forEach(function(li){
        var hit=null;tileText(li).some(function(t){if(byOpt[t]&&byOpt[t].length===1){hit=byOpt[t][0];return true}});
        var had=li.hasAttribute('data-pd-variant');
        if(!hit){if(had){li.removeAttribute('data-pd-variant');li.querySelectorAll('.pd-swatch-badge,.pd-swatch-price').forEach(function(e){e.remove()})}return}
        if(had&&li.getAttribute('data-pd-variant')===hit)return;
        li.setAttribute('data-pd-variant',hit);
        var b=document.createElement('span');b.className='pd-swatch-badge';b.textContent='PRICE DROP';li.appendChild(b);
        var p=document.createElement('span');p.className='pd-swatch-price';p.innerHTML='<span class="pd-now"></span><span class="pd-was"></span>';
        p.firstChild.textContent=m[hit].price;p.lastChild.textContent=m[hit].orig;
        (li.querySelector('label')||li).appendChild(p);
      });
    });
  }
  function refresh(){Object.keys(M).forEach(function(pid){var v=curVid(pid);if(v)setMain(pid,v)});badges()}
  document.addEventListener('booster:variant:select',function(e){var d=e.detail||{};if(d.product&&d.selectedVariant){setMain(String(d.product.id),d.selectedVariant.id)}});
  document.addEventListener('change',function(){setTimeout(refresh,0)},true);
  window.addEventListener('popstate',refresh);
  var lastUrl=location.href;setInterval(function(){if(location.href!==lastUrl){lastUrl=location.href;refresh()}},400);
  function start(){M=maps();if(!Object.keys(M).some(function(k){return Object.keys(M[k]).length}))return;refresh();
    var n=0,iv=setInterval(function(){badges();if(++n>20)clearInterval(iv)},500);
    var bq=false;new MutationObserver(function(){if(bq)return;bq=true;requestAnimationFrame(function(){bq=false;badges()})}).observe(document.body,{childList:true,subtree:true}); /* speed-1019: once per frame */
    document.querySelectorAll('input[data-bstr-variant-input]').forEach(function(i){new MutationObserver(refresh).observe(i,{attributes:true,attributeFilter:['value']})});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
